import { Pipe, PipeTransform } from '@angular/core';
import { MeterDataStoreServiceDirective } from '@app/shared/services/store/meter-data-store.service';

@Pipe({
  name: 'getMeterTypeImage',
})
export class GetMeterTypeImagePipe implements PipeTransform {
  constructor(private meterDataStoreServiceDirective: MeterDataStoreServiceDirective) {}

  transform(element: any) {
    return this.meterDataStoreServiceDirective.getMeterTypeImage(element.meterTypesName ?? element.meterType.code, element.deviceId);
  }
}
